module.exports = __webpack_public_path__ + "static/fonts/Nunito-ExtraBoldItalic.e365ed8.woff2";